/**
 * GeChiUI dependencies
 */

import { ToolbarButton } from '@gechiui/components';
import { __ } from '@gechiui/i18n';
import { rotateRight as rotateRightIcon } from '@gechiui/icons';

/**
 * Internal dependencies
 */
import { useImageEditingContext } from './context';

export default function RotationButton() {
	const { isInProgress, rotateClockwise } = useImageEditingContext();
	return (
		<ToolbarButton
			icon={ rotateRightIcon }
			label={ __( 'Rotate' ) }
			onClick={ rotateClockwise }
			disabled={ isInProgress }
		/>
	);
}
